import axios from 'axios';
import { fulfilled } from '../utils/helpers';

export const types = {
  FETCH_CRIME_TYPES: 'FETCH_CRIME_TYPES',
};

export const fetchCrimeTypes = () => ({
  type: types.FETCH_CRIME_TYPES,
  payload: axios.get('/crimetypes').then(response => response.data.data),
});

export const initialState = [{ id: 300, name: 'Nonfatal Shootings' }];

export default (state = initialState, { type, payload }) =>
  type === fulfilled(types.FETCH_CRIME_TYPES) ? payload : state;

export const getCrimeTypes = state => state.crimeTypes;



// WEBPACK FOOTER //
// ./src/reducers/crimeTypes.js